<template>
  <div class="countdown-circle">
    <app-cirlce :percent="percent" :stroke-width="2" stroke-color="#57aef1" trail-color="#fff">
      <p class="countdown-time">{{time}}</p>
      <p class="countdown-text">剩余时间</p>
    </app-cirlce>
  </div>
</template>

<script>
import Cirlce from './Circle'
export default {
  name: 'CountdownCircle',
  components: { 'app-cirlce': Cirlce },
  props: {
    startTime: { type: Number },
    endTime: { type: Number }
  },
  data() {
    return {
      percent: 100,
      currentTime: null,
      timer: null
    }
  },
  computed: {
    time() {
      let t = this.endTime - this.currentTime
      if (t > 0) {
        let minutes = Math.floor((t / 1000 / 60) % 60)
        let seconds = Math.floor((t / 1000) % 60)
        return `${this.leftPad(minutes)}:${this.leftPad(seconds)}`
      } else {
        return `00:00`
      }
    }
  },
  methods: {
    start() {
      this.currentTime = +new Date()
      this.timer = setInterval(() => {
        if (this.currentTime >= this.endTime) {
          this.percent = 0
          this.stop()
          this.$emit('on-finish', this.currentTime)
        } else {
          this.currentTime = +new Date()
          this.percent =
            100 +
            Math.floor(
              (this.currentTime - this.startTime) /
                (this.endTime - this.startTime) *
                100
            )
        }
      }, 1000)
    },
    stop() {
      clearInterval(this.timer)
    },
    leftPad(n) {
      return n < 10 ? '0' + n : n
    }
  },
  created() {
    this.start()
  },
  beforeDestroy() {
    this.stop()
  }
}
</script>

<style>
.countdown-circle {
  width: 0.6rem;
  height: 0.6rem;
  min-width: 60px;
  min-height: 60px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
  padding: 0.05rem;
}
.countdown-circle .countdown-time {
  font-size: 14px;
  color: #666;
  text-align: center;
  font-weight: 600;
}
.countdown-circle .countdown-text {
  font-size: 12px;
  line-height: 1;
  color: #999;
  transform: scale(0.6);
}
</style>
